@if (isLoading) {
<div class="overlay h-100 d-flex flex-column align-items-center justify-content-center position-absolute w-100 top-index">
    <div class="spinner-border" role="status"></div>
</div>
}
@if (shouldShowNoDataMessage) {
<div class="overlay h-100 d-flex flex-column align-items-center justify-content-center position-absolute w-100 top-index">
    No Data To Display
</div>
}
